// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsSentSearchResponse

import { hydrateSmsSent, type SmsSent, type SmsSentApiResponse } from './smsSent.gen';

export type SmsSentSearchApiResponse = {
	items: SmsSentApiResponse[];
};

export type SmsSentSearch = {
	items: SmsSent[];
};

export function hydrateSmsSentSearch(data: SmsSentSearchApiResponse): SmsSentSearch {
	return {
		...data,
		items: data.items.map(hydrateSmsSent),
	};
}